import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import HomeServices from '@/modules/home/services/home.js';

export default new Vuex.Store({
    state: {
        settings: {
            energy: [],
            attach_energy_num: -1,
        }
    },
    mutations: {
        setSettings(state, settings) {
            state.settings = settings;
        }
    },
    actions: {
        async getSettings({commit}, project_id) {
            const res = await HomeServices.getProjectList();
            if (res.status) {
                const data = res.data.filter(item => {
                    return item.id === project_id;
                })[0];
                const energy_arr = [];
                if (data.energy_desc_dic && data.energy_desc_dic.length - 2 >= data.attach_energy_num) {
                    for (let i = 0; i < data.attach_energy_num + 2; i++) {
                        if (i > 1) {
                            energy_arr.push(data.energy_desc_dic[i]);
                        }
                    }
                }
                commit("setSettings", {
                    energy: energy_arr,
                    attach_energy_num: data.attach_energy_num,
                });
            }
        }
    }
});
